module.exports = __webpack_public_path__ + "static/new-favicon-fd938c2e16820fdb76356aebd49d6361.png";